import React, { useEffect, useState } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import QuickView from "./QuickView";
import { Link } from "gatsby";
import { getClubPrice } from "../../../utils/clubPrice";
import CardPricing from "./Pricing";
import RatingView from "./Rating";
import { LOGGEDIN } from "../../../constants/auth";
import { useSelector } from "react-redux";
import ColorsView from "./ColorsView";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";

function ProductCard({ product, showOnSale }) {
  const [productData, setProductData] = useState(product);
  const [clubPrice, setClubPrice] = useState(null);
  const { authState } = useSelector((state) => state.auth);

  useEffect(() => {
    setProductData(product);
    setClubPrice(getClubPrice(product));
  }, [product]);

  return (
    <Dialog>
      <div
        className={`relative w-full pr-5 box-border group`}
      >
        <div className="relative w-full bg-transparent rounded-xl aspect-[auto 799/1024]">
          <Link to={`/products/${product?.handle}`} className="w-full">
            {product?.media[1]
              ? product?.media[1].preview.image?.gatsbyImageData && (
                  <div className="absolute w-full h-full top-0 rounded-xl z-[-1]">
                    <GatsbyImage
                      loading="lazy"
                      image={product?.media[1].preview.image?.gatsbyImageData}
                      alt={product?.media[1].preview.image?.altText}
                      className="relative w-full h-full rounded-xl z-[-1] object-cover"
                    />
                  </div>
                )
              : product?.media[0]?.preview?.image?.gatsbyImageData && (
                  <div className="absolute w-full h-full top-0 rounded-xl z-[-1]">
                    <GatsbyImage
                      loading="lazy"
                      image={product?.media[0].preview.image?.gatsbyImageData}
                      alt={product?.media[0].preview.image?.altText}
                      className="relative w-full h-full rounded-xl z-[-1] object-cover"
                    />
                  </div>
                )}
            {product?.media[0]?.preview?.image?.gatsbyImageData && (
              <div className="w-full h-full bg-transparent">
                <GatsbyImage
                  loading="lazy"
                  image={product?.media[0].preview.image?.gatsbyImageData}
                  alt={product?.media[0].preview.image?.altText}
                  className="w-full h-full object-cover rounded-xl transition-all duration-300 ease-linear opacity-100 z-10 hover:opacity-0"
                />
              </div>
            )}
          </Link>
        </div>
        <Link to={`/products/${product?.handle}`}>
          <h3 className="text-[14px] md:text-base font-bold mb-[6px] mt-3 group-hover:opacity-100">
            {product?.title}
          </h3>
          <div
            className="font-semibold text-xs transition-all duration-300 ease-linear
          group-hover:opacity-100"
        >
          {(product.reviewsCount?.value ?? 0) > 0 && (
            <RatingView
              reviewCount={product.reviewsCount}
              reviewAverage={product.reviewsAverage}
            />
          )}
          <div className="flex flex-wrap w-full min-h-[60px]">
            <CardPricing
              clubPrice={clubPrice}
              variant={productData?.variants[0]}
              isAuthenticated={authState === LOGGEDIN}
            />

              {product?.options?.find(
                (option) => option.name === "Color" || option.name === "Colour"
              )?.values?.length > 1 && (
                <ColorsView url={`/products/${product?.handle}`} />
              )}
            </div>
          </div>
        </Link>
      </div>
      <QuickView product={{ ...productData }} clubPrice={clubPrice} />
    </Dialog>
  );
}

export default ProductCard;
